// ==================================
// GENERIC UTILS
// ==================================

import axios from "axios";

let UtilitiesPlugin = {};

UtilitiesPlugin.install = function (Vue, {router, store}) {


    let debounce = (callback, wait) => {

        let timeout;
        return (...args) => {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                callback.apply(context, args);
            }, wait);

        };
    };


    let smoothScrollTo = (destinationScrollTop) => {

        let animateScrollTo = (to, duration) => {

            if (duration <= 0) {
                return;
            }
            let crtScrollTop = window.scrollY || window.pageYOffset;
            let difference = to - crtScrollTop;
            let perTick = difference / duration * 10;

            setTimeout(function() {
                window.scroll(0, (crtScrollTop+perTick));
                if ((crtScrollTop + perTick) == to) {
                    return;
                }
                else {
                    animateScrollTo(to, duration - 10);
                }
            }, 10);
        };

        // If the browser supports smooth scroll, use it. Otherwise, use the custom function.
        if ('scrollBehavior' in document.documentElement.style) {
            window.scroll({
                top : destinationScrollTop,
                behavior : 'smooth'
            });
        }
        else {
            animateScrollTo(destinationScrollTop, 100);
        }
    };

    let smoothScrollElementTo = (destinationScrollTop, element) => {

        let animateScrollElemTo = (to, duration) => {

            if (duration <= 0) {
                return;
            }
            let crtScrollTop = element.scrollTop;
            let difference = to - crtScrollTop;
            let perTick = difference / duration * 10;

            setTimeout(function() {
                element.scrollTop = (crtScrollTop+perTick);
                if ((crtScrollTop + perTick) == to) {
                    return;
                }
                else {
                    animateScrollElemTo(to, duration - 10);
                }
            }, 10);
        };

        // If the browser supports smooth scroll, use it. Otherwise, use the custom function.
        if ('scrollBehavior' in document.documentElement.style) {
            element.scroll({
                top : destinationScrollTop,
                behavior : 'smooth'
            });
        } else {
            animateScrollElemTo(destinationScrollTop, 100);
        }
    };


    /**
     * Returns the height of an element, NOT including padding, border etc., just its content height.
     * @param elem - The element to be measured.
     */
    let getElemHeight = (elem) => {

        let elemHeight;
        try {
            elemHeight = window.getComputedStyle(elem, null).getPropertyValue('height'); // Modern browsers.
        } catch(e) {
            elemHeight = elem.currentStyle.height; // Browsers that don't know the modern way.
        }

        return elemHeight;
    };


    /**
     * Build an array of URL params, based on current URL. It only looks in window.location.search, it ignores the params from Vue's router.query.
     *
     * @return {Object} - Object containing the list of URL query params as key:value pairs.
     *
     * @example For example, if the current url has "?param1=value1&param2=value2" params, this function will return the following object: {param1:"value1", param2:"value2"}
     */
    let obtainUrlParamsObj = () => {
        return window.location.search
            .slice(1)
            .split('&')
            .map(p => p.split('='))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    };


    /**
     * Create form for voucherCallbackData or autologin.
     * @param {String} redirectUrl - The URL to send the POST request to. This will be used as "action" attribute on the form created by this function.
     *
     * @param {Object} paramMap - The data to be sent to the URL. For each property in this object will be created a hidden input in the form
     *                            that will be submitted to the URL specified in "url" param.
     *
     * @param {String} patientConsentProperty - The AppProperty PATIENT_CONSENT, if is true a consent checkbox is displayed above the Continue button
     *                                          and the continue button is only enabled if the consent checkbox has been clicked.
     */
    function createFormForData(redirectUrl, paramMap, patientConsentProperty) {

        if (typeof redirectUrl !== 'undefined' && redirectUrl !== null) {

            let form = document.createElement('form');
            form.id = 'callbackDataFormId'
            form.method = 'POST';
            form.action = redirectUrl;


            if (patientConsentProperty === 'true') {

                let field = document.createElement('input');
                field.id = 'consentFormId'
                field.name = 'consent';
                field.type = 'hidden';

                form.appendChild(field);
            }

            if (typeof paramMap !== 'undefined' && paramMap !== null) {

                for (let key in paramMap) {

                    let field = document.createElement('input');
                    field.name = key;

                    field.type = 'hidden';
                    field.value = paramMap[key];
                    form.appendChild(field);
                }
            }

            document.body.appendChild(form);
        }
    }


    /**
     * Simulate a form.submit(). Sends a request to the specified URL from a form that is dynamically created only for this purpose.
     * It will redirect the page to the URL specified in "url" param.
     */
     function submitDataForm(isPfi, consentCheckboxValue) {

        let form = document.getElementById("callbackDataFormId");
        if (form === null) {
            console.error("Unexpected error! Couldn't find callbackDataFormId.");
            return;
        }

        // for Pfi save Continue Button Click and PatientConsent, then submit form
        if (isPfi === true) {
            axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/continueClicked', {value: consentCheckboxValue}).then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    form.submit();
                }
                else {
                    console.error("Unexpected error! Couldn't save Patient Consent.");
                }
            });
        }
        // for Pro auto-login submit form
        else {
            form.submit();
        }
    }

    /**
     * Creates a hex string with a random color.
     * This method is for TESTING PURPOSE ONLY (like checking if/when events are triggered in iPhone Safari), so it's NOT NEEDED IN PRODUCTION.
     */
    let generateRandomColorHex = () => {
        let letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    /**
     * Sets a cookie.
     * @param name
     * @param value
     * @param days
     */
    let setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    };

    let getCookie =  (name) => {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length === 2) {
            return parts.pop().split(";").shift();
        }
    }



    // ==================================
    // Export
    // ==================================

    // Export for components.
    Vue.mixin({
        computed: {
            UtilitiesPlugin: () => {
                return {
                    debounce: debounce,
                    smoothScrollTo: smoothScrollTo,
                    smoothScrollElementTo: smoothScrollElementTo,
                    getElemHeight: getElemHeight,
                    obtainUrlParamsObj: obtainUrlParamsObj,
                    createFormForData: createFormForData,
                    submitDataForm: submitDataForm,
                    generateRandomColorHex: generateRandomColorHex,
                    setCookie: setCookie,
                    getCookie: getCookie
                }
            }
        }
    });

    // Export functions to be used in other places like other plugins, router and so on.
    Vue.UtilitiesPlugin = {
        debounce: debounce,
        smoothScrollTo: smoothScrollTo,
        smoothScrollElementTo: smoothScrollElementTo,
        getElemHeight: getElemHeight,
        obtainUrlParamsObj: obtainUrlParamsObj,
        createFormForData: createFormForData,
        submitDataForm: submitDataForm,
        generateRandomColorHex: generateRandomColorHex,
        setCookie: setCookie,
        getCookie: getCookie
    };
    // For some reason, it seems we have to add it to Vue.prototype too if we want to call it from another plugin (even when we are calling it Vue.UtilitiesPlugin from the other plugin).
    Vue.prototype.$UtilitiesPlugin = {
        debounce: debounce,
        smoothScrollTo: smoothScrollTo,
        smoothScrollElementTo: smoothScrollElementTo,
        getElemHeight: getElemHeight,
        obtainUrlParamsObj: obtainUrlParamsObj,
        createFormForCallbackData: createFormForData,
        sendVoucherDataForm: submitDataForm,
        generateRandomColorHex: generateRandomColorHex,
        setCookie: setCookie,
        getCookie: getCookie
    };

};

export default UtilitiesPlugin;



// WEBPACK FOOTER //
// ./src/common/plugins/UtilitiesPlugin.js